var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueFeedback',{attrs:{"type":"no-result"}},[_c('template',{slot:"feedback-title"},[_vm._v("There are no items matching the search criteria")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }